import { AGE, FUNCTION, GENDER, TIER, USE_CASE } from '@d-id/tts';
import { Providers } from '@d-id/types';
import { atom } from 'recoil';

export const ttsVoiceSourceFilter = atom<'default' | 'imported'>({
    key: 'tts-voice-filter',
    default: 'imported',
});

export const ttsVoiceSearchFilter = atom<string>({
    key: 'tts-voice-search-filter',
    default: '',
});

export const ttsVoiceLanguageFilter = atom<string | 'english'>({
    key: 'tts-voice-language-filter',
    default: 'all',
});

export const ttsVoiceGenderFilter = atom<GENDER | 'all'>({
    key: 'tts-voice-gender-filter',
    default: 'all',
});

export const ttsVoiceAgeFilter = atom<AGE | 'all'>({
    key: 'tts-voice-age-filter',
    default: 'all',
});

export const ttsVoiceUseCaseFilter = atom<USE_CASE | 'all'>({
    key: 'tts-voice-use-case-filter',
    default: 'all',
});

export const ttsVoiceTierFilter = atom<TIER | 'all'>({
    key: 'tts-voice-tier-filter',
    default: 'all',
});

export const ttsVoiceFunctionFilter = atom<FUNCTION[]>({
    key: 'tts-voice-function-filter',
    default: [],
});

export const ttsVoiceProviderFilter = atom<Providers[]>({
    key: 'tts-voice-provider-filter',
    default: [],
});
